import { Collapse, Grid } from "@material-ui/core";
import { useQuery } from "@tanstack/react-query";
import { getMentorSummary } from "../../services";
import { useStyles } from "./about-me-mentor.styles";
import AchievementsMentor from "./achievements-mentor/achievements-mentor.component";
import ExpertisesMentor from "./expertises-mentor/expertises-mentor.component";
import VideoMentor from "./video-mentor/video-mentor.component";

interface AboutMeProps {
  educatorId: string;
  expanded: boolean;
}

function AboutMe({ educatorId, expanded }: AboutMeProps) {
  const classes = useStyles();

  const { data: mentorSummaryData } = useQuery({
    queryKey: ["non-participant", educatorId],
    queryFn: () => getMentorSummary(educatorId),
  });

  return mentorSummaryData ? (
    <Collapse in={expanded}>
      <Grid container spacing={2} className={classes.mainContainer}>
        <Grid item className={classes.aboutMeContainer}>
          <VideoMentor
            videoSource={mentorSummaryData?.profileVideoLink}
            data-testid="video-mentor"
          />
        </Grid>
        <Grid item>
          <ExpertisesMentor
            data={mentorSummaryData?.expertises}
            data-testid="expertises-mentor"
          />
        </Grid>
        <Grid item>
          <AchievementsMentor
            data={mentorSummaryData?.achievements}
            data-testid="achievements-mentor"
          />
        </Grid>
      </Grid>
    </Collapse>
  ) : null;
}

export default AboutMe;
